import apiConfig from "./apiConfig";
import { goToApp } from "./siteLinks";

// Marketing-site fetch wrapper. Marketing only hits anonymous endpoints
// (e.g. /tour-templates, /fuel-prices). There's no Cognito session to
// refresh and no Authorization header to attach. If the API ever returns
// 401 it means an endpoint we expected to be public is gated — bounce to
// the app's login so the user can establish a session and try again.
export const apiFetch = async (path, options = {}) => {
    const response = await fetch(`${apiConfig.baseURL}${path}`, options);
    if (response.status === 401) {
        goToApp(`/login?from=${encodeURIComponent(window.location.pathname + window.location.search)}`);
    }
    return response;
};
